<ap-header type="solid" [compact]="false">
  <ng-template ngTemplate="title">{{ 'title' | translate }} </ng-template>
  <ng-template ngTemplate="sub-title">
    <gstar-client-selection />
  </ng-template>

  <ng-template ngTemplate="options">
    @if (showHeaderSearch()) {
      <gstar-global-search class="compact" variant="compact" />
    }

    @if (notificationCounter() !== '') {
      <button
        class="d-inline-flex align-items-center bg-transparent"
        (click)="openNotifications()">
        <ap-badge
          [value]="notificationCounter()"
          type="danger"
          styleClass="ap-bg-orange"
          size="large" />
        <span
          class="Appkit4-icon icon-notification-outline"
          ap-tooltip
          [tooltipContent]="'notification.title' | translate"
          direction="top"></span>
      </button>
    }

    <ap-header-options-item
      iconName="help-question-outline"
      (click)="openContactUs()"
      ap-tooltip
      direction="top"
      [tooltipContent]="'header.contactUs.helpTooltipButton' | translate" />

    <ap-header-options-item
      iconName="setting-outline"
      ap-tooltip
      [tooltipContent]="'admin.settings.title' | translate"
      direction="top"
      (click)="openSettings()" />
  </ng-template>

  <ng-template ngTemplate="user">
    <ap-avatar
      diameter="40"
      borderWidth="0"
      [name]="userInitials()"
      [disabled]="false"
      [withDropdown]="true"
      [list]="avatarMenuItems"
      [ariaLabel]="'settings menu'">
      <ng-template ngTemplate="dropdownTemp">
        <p class="m-2">{{ 'header.welcome' | translate }} {{ userMail() }}</p>
        <hr />
        @for (item of avatarMenuItems; track $index) {
          <ap-dropdown-list-item
            #dropdownListItem
            [item]="item"
            (onSelectItem)="selectItem($event)">
            @if (item.iconName) {
              <ng-template ngTemplate="prefixTemp">
                <span class="Appkit4-icon icon-{{ item.iconName }}"></span>
              </ng-template>
            }
          </ap-dropdown-list-item>
        }
      </ng-template>
    </ap-avatar>
  </ng-template>
</ap-header>
